export type NewType<A extends number | string | boolean> = A & { readonly __tag: unique symbol }

type BaseOf<A> = A extends NewType<infer Base> ? Base : never

export const to = <A extends NewType<any>>(value: BaseOf<A>) => value as A

export const from = <A extends NewType<any>>(value: A) => value as BaseOf<A>